import { atom } from 'recoil'

import type {
  ListsState,
  MobilePrefixesState,
} from 'Pages/RecipientsList/model'

export const listsState = atom<ListsState>({
  key: 'recipientsList_listsState',
  default: {
    items: [],
    loaded: false,
  },
})

export const countryCodesState = atom<MobilePrefixesState>({
  key: 'recipientsList_countryCodesState',
  default: {
    loaded: false,
    items: [],
  },
})

export const maskedFieldsState = atom<string[]>({
  key: 'recipientsList_maskedFieldsState',
  default: [],
})
